import { Box, Typography } from "@mui/material";
import { fontColor } from "../../../constants/ColorSets";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";

export const UnreadAlert = () => {
  return (
    <Box
      sx={{
        width: "fit-content",
        display: "flex",
        alignItems: "center",
        px: 1.5,
        py: 0.5,
        backgroundColor: fontColor.orangeSelectedBackground,
        borderRadius: "10px",
        color: fontColor.warningFontColor,
      }}
    >
      <ChatBubbleOutlineRoundedIcon fontSize="small" sx={{ height: "17px", mr: 0.5 }} />
      <Typography sx={{ fontWeight: "600", fontSize: 12 }}>Un-responded</Typography>
    </Box>
  );
};
